import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { productOccupancyStates, titleForProductOccupancyState } from 'zens-store'

interface Props extends Omit<SelectProps<number | number[]>, 'items' | 'onSelect'> {
  onChange?: (value: number | number[]) => void
}
const OccupancySelect = (props: Props) => {
  const { onChange, value, ...otherProps } = props
  const { t } = useTranslation()

  const items = productOccupancyStates.map((status) => ({
    value: status,
    title: titleForProductOccupancyState(status, t),
  }))
  return (
    <Select
      value={value || 'all'}
      onSelect={onChange}
      items={items}
      testID="OccupancySelect.Container"
      {...otherProps}
    />
  )
}

export default OccupancySelect
